import './Footer.css'
import useUrlParams from '../../hooks/useUrlParams';
import useUrlNavigation from '../../hooks/useUrlNavigation';
import CircularProgressbar from '../../custom_components/circular_progress/CircularProgressbar';
import { useEffect, useState } from 'react';
import useScenario from '../../hooks/useScenario';
import useTrueTwin from '../../hooks/useTrueTwin';
import { CircularProgress } from '@mui/material';
import useViewer from '../../hooks/useViewer';
import Dialog from '../../../CommonComponents/Dialog';
import { get_formated_time } from '../../utils';
import { get_button_list } from './utils';
import CustomToolTip from '../../../CommonComponents/CustomToolTip';
import useLoader from '../../hooks/useLoader';


const Footer = () => {

  const { scenario, simulation_time } = useScenario()
  const { loading } = useLoader()
  const { navigate_to, navigate_dashboard } = useUrlNavigation()
  const { dashboard, tab_name } = useUrlParams();
  const { current_simulation_time } = useViewer()
  const { TrueTwin, unDeployLoader, dis_connect_ground_station } = useTrueTwin()
  const [openDialouge, setOpenDialouge] = useState<boolean>(false);
  const [scenarioTime, setScenarioTime] = useState<{
    "start_time": number;
    "end_time": number;
  }>({
    "start_time": 0,
    "end_time": 0,
  })

  const show_Left_right_btn_container = dashboard !== 'operate'
  const show_back_btn_container = dashboard === 'operate'
  const show_scenario__timer__container = dashboard !== 'quick-deploy' && current_simulation_time > 0

  const ButtonsList = get_button_list(tab_name, dashboard)


  useEffect(() => {
    if (simulation_time?.start_time) {
      const start_time = simulation_time?.start_time
      const end_time = simulation_time?.end_time
      setScenarioTime({
        "start_time": start_time,
        "end_time": end_time
      })
    }
  }, [simulation_time]);


  const onclick = () => {
    if (dashboard === "summary") {
      navigate_dashboard()
      sessionStorage.setItem("multiplierValue", "1")
    } else {
      setOpenDialouge(true)
    }
  }

  const name = dashboard === 'quick-deploy' ? TrueTwin?.['Name'] : scenario?.['scenarioName']

  return (
    <div className={`command__center_footer ${(!TrueTwin || !scenario) && 'disabled'}`}>
      <div className='footer__left_button_container'>
        <div className='footer__left__button'>
          <CustomToolTip title={name} placement='top-start'>
            {name}
          </CustomToolTip>
          <span>{dashboard === 'summary' ? 'Summary' : dashboard === 'quick-deploy' ? 'Quick Deploy' : dashboard === 'simulation' ? 'Simulation' : 'Operate'}</span>
        </div>
      </div>
      <div className='footer__center_button_container'>
        {ButtonsList.map((button, index) => {
          const { label, svg, show, active } = button;
          return (
            <button
              key={index}
              disabled={loading}
              className={`footer__center__button ${active && 'active'} ${!show && 'hide'}`}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation()
                const tabname = label.toLowerCase() === 'plan' ? 'plan-onboard-schedule' : label.toLowerCase()
                navigate_to(tabname)
              }}
            >
              {svg}
              <span>{label}</span>
            </button>
          )
        })}
      </div>
      {(show_Left_right_btn_container && show_scenario__timer__container) &&
        <div className='scenario__timer__container'>
          <CircularProgressbar
            simulation_current_time={current_simulation_time / 1000}
            simulation_start_time={scenarioTime?.start_time}
            simulation_end_time={scenarioTime?.end_time}
          />
          <div className='separator' />
          <div className='time__container'>
            <span>{current_simulation_time && get_formated_time(current_simulation_time / 1000)}</span>
            <span>{scenarioTime?.end_time && get_formated_time(scenarioTime?.end_time)}</span>
          </div>
        </div>
      }
      {show_Left_right_btn_container &&
        <div className='footer__right_button_container'>
          <button
            disabled={unDeployLoader ? true : false}
            className='footer__right_button' onClick={onclick}>
            {dashboard === "summary" ? "Close" : unDeployLoader ? 'Retiring' : dashboard !== 'quick-deploy' ? "End Simulation" : 'Retire'}
            {unDeployLoader && <CircularProgress size={16} color='inherit' />}
          </button>
        </div>
      }
      {show_back_btn_container &&
        <div className='footer__right_button_container'>
          <button
            className='footer__right_button' onClick={navigate_dashboard}>
            Back
          </button>
        </div>
      }
      <Dialog onClick={(event: boolean) => {
        if (event) {
          dis_connect_ground_station()
        }
        setOpenDialouge(false)
      }} openModel={openDialouge} comment={`Are you sure you want to ${dashboard !== 'quick-deploy' ? "end this simulation" : 'retire this truetwin'} ?`} />
    </div>
  )
}

export default Footer